import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SuspensionReason } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class SuspensionReasonService extends UzurvRestService {
  readonly resourceUrl = 'suspensionReasons/';

  constructor(
    protected httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    protected domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * List suspension reasons that are used for a rider
   *
   * @permission rider_suspension_read
   */
  listRiderSuspensionReasons(): Observable<Array<SuspensionReason>> {
    return this.get<Array<SuspensionReason>>(`${this.resourceUrl}useWithRiders/`).pipe(
      map(response => Deserialize(response, SuspensionReason))
    );
  }
}
